import React from 'react'
import LoggedOut from './LoggedOut'
import ServiceUnavailableError from './ServiceUnavailableError'
import NotFoundError from './NotFoundError'
import TokenExpired from './TokenExpired'
import ErrorCritical from './ErrorCritical'
import RevokeConsent from './RevokeConsent'
import EbankingBackstop from './EbankingBackstop'
import CustomerNotFound from './CustomerNotFound'
import TokenExpiredStaff from './TokenExpiredStaff'
import ErrorCriticalStaff from './ErrorCriticalStaff'
import LinkNotFound from './LinkNotFound'
import CancelLink from './CancelLink'

const Error = ({ error, brand, isStaffMember, linkId }) =>
  isStaffMember ? (
    <StaffError error={error} linkId={linkId} />
  ) : (
    <CustomerError error={error} brand={brand} />
  )

const CustomerError = ({ error, brand }) => (
  <div className="zb-container">
    {{
      'token-expired': <TokenExpired brand={brand} />,
      'logged-out': <LoggedOut brand={brand} />,
      'page-not-found': <NotFoundError brand={brand} />,
      'service-unavailable': <ServiceUnavailableError brand={brand} />,
      'revoke-consent': <RevokeConsent brand={brand} error={error} />,
      'ebanking-backstop': <EbankingBackstop brand={brand} />,
    }[error.type] || <ErrorCritical brand={brand} error={error} />}
  </div>
)

const StaffError = ({ error, linkId }) => (
  <div className="zb-container">
    {{
      'token-expired': <TokenExpiredStaff />,
      'customer-not-found': <CustomerNotFound />,
      'link-not-found': <LinkNotFound />,
      'cancel-link': <CancelLink linkId={linkId} />,
    }[error.type] || <ErrorCriticalStaff />}
  </div>
)

export default Error
